import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Text = styled.div`
  font-size: var(--global-font-size-s);
  margin: 4px;
  padding: 0.04px;
`;

const FAQListDiv = styled.div`
  font-size: var(--global-font-size-m);
  line-height: 1.8;
`;

const ListItem: React.FC<{ q: JSX.Element; a: JSX.Element; index: number }> = ({
  q,
  a,
}) => {
  return (
    <div style={{ marginBottom: "24px" }}>
      <Text>
        <strong>Q: {q}</strong>
      </Text>
      <Text>A: {a}</Text>
    </div>
  );
};

const AnswerComponent: React.FC<{ text: any }> = ({ text }) => {
  return text;
};

const FAQ_LIST_CONTENT = [
  {
    q: (
      <span>
        How many developers in my organization are currently using Semgrep
        Community?
      </span>
    ),
    a: (
      <AnswerComponent
        text={[
          `If you're a Semgrep Community Tier user, you can
        check your organization's current developer usage by going to `,
          <b>
            <Link
              to="/orgs/-/settings/upgrade?utm_source=website&utm_medium=app&utm_id=0x14&utm_campaign=pricingfaq"
              target="_blank"
            >
              'Semgrep App → Settings → Upgrade'
            </Link>
          </b>,
        ]}
      />
    ),
  },
  {
    q: <span>What happens if I exceed the usage limit in a given month?</span>,
    a: (
      <span>
        When your organization exceeds 20 developers, you will start receiving
        in-app and email notifications notifying you that a 30-day grace period
        has been triggered. During this time, your Semgrep functionality won't
        be affected; as your security tool, we don't want to abruptly be taken
        away! After this grace period ends, additional developers (the 21st
        onward) won't receive notifications or comments, and findings introduced
        by them won't be surfaced in Semgrep App.
      </span>
    ),
  },
  {
    q: <span>Why is a usage limit being introduced?</span>,
    a: (
      <span>
        The Community tier is intended for small teams and open source projects,
        while our Team and Enterprise tiers are designed for larger
        organizations. Over the past year as Semgrep App has grown in
        popularity, we've been thrilled to see organizations adopting it deeply
        and widely across all of their projects. We want to make sure that we
        are able to continue offering a free Community tier while also building
        a sustainable business on top of open-source. The usage limit updates
        helps us codify this intention.
      </span>
    ),
  },
  {
    q: <span>What is a developer?</span>,
    a: (
      <span>
        A developer is someone who made a commit to your organization's private
        repository scanned by Semgrep in the past month.
      </span>
    ),
  },
  {
    q: <span>When does this limit go into effect?</span>,
    a: (
      <span>
        These updates will be effective August 1st, 2022 for new organizations.
        We're also offering an additional grace period until November 1st, 2022
        for existing organizations who have questions or concerns.
      </span>
    ),
  },
  {
    q: <span>Are discounts available?</span>,
    a: (
      <span>
        We love startups, OSS projects, and students! If this describes you,
        please contact us for pricing. We also offer a 30-day trial of the Team
        tier for organizations who are considering upgrading.
      </span>
    ),
  },
  {
    q: (
      <span>
        Do these updates apply to me if I'm currently in a trial of Semgrep?
      </span>
    ),
    a: (
      <span>
        If you are currently in talks with a member of our team and in a trial
        of Semgrep, these updates will not affect you for the duration of the
        trial.
      </span>
    ),
  },
  {
    q: <span>How will I be notified of these updates?</span>,
    a: (
      <span>
        Impacted organizations will be notified in two ways: through an email to
        members of your Semgrep organization sent in June 2022 and via Semgrep
        App notifications.
      </span>
    ),
  },
  {
    q: (
      <span>
        How long is my data stored with r2c if I don't upgrade to Teams?
      </span>
    ),
    a: (
      <span>
        Semgrep App will retain findings for organizations who exceed the 20
        developer limit. These findings will be retained and accessible upon
        upgrading to Team or Enterprise tiers for up to 3 months.
      </span>
    ),
  },
];

export const UsageLimitsFAQ: React.FC = () => {
  return (
    <FAQListDiv>
      {FAQ_LIST_CONTENT.map(({ q, a }, index) => (
        <ListItem key={index} q={q} a={a} index={index} />
      ))}
    </FAQListDiv>
  );
};
